<template>
    <nav class="navbar navbar-default"> 
        <div class="navbar-header">
            <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false" @click="toggleCollapse">
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
            </button>
        </div>
        <div v-bind:class="['navbar-collapse',{collapse:data.collapsed}]" id="bs-example-navbar-collapse-1">
            <ul class="nav navbar-nav">
                <li class="dropdown" v-bind:class="data.adminDisplay" v-if="config.hasPerm('add_channel') || config.hasPerm('add_area') || config.hasPerm('add_company') || config.hasPerm('add_datenotavailable') || config.hasPerm('add_user')  || config.hasPerm('add_reason')  || config.hasPerm('add_subreason') || config.hasPerm('add_unit')">
                    <a href="javascript:void(0);" v-on:click="toggleOptionsAdmin()" class="dropdown-toggle" data-toggle="dropdown">Administración <span class="caret" id="menu-admin"></span></a>
                    <ul class="dropdown-menu">
                        <li><router-link v-on:click.native="hideOptions()" to="/User">Usuarios</router-link></li>
                        <li><router-link v-on:click.native="hideOptions()" to="/Unit">Unidades</router-link></li>
                        <li><router-link v-on:click.native="hideOptions()" to="/Area">Áreas</router-link></li>
                        <li><router-link v-on:click.native="hideOptions()" to="/Reason">Motivos</router-link></li>
                        <li><router-link v-on:click.native="hideOptions()" to="/Subreason">Sub motivos</router-link></li>
                        <li><router-link v-on:click.native="hideOptions()" to="/Channel">Canales</router-link></li>
                        <li><router-link v-on:click.native="hideOptions()" to="/Company">Empresa o filial</router-link></li>
                        <li><router-link v-on:click.native="hideOptions()" to="/DateNotAvailable">Días no hábiles</router-link></li>
                        <li><router-link v-on:click.native="hideOptions()" to="/Export">Exporte</router-link></li>
                        <li><router-link v-on:click.native="hideOptions()" to="/Genero">Géneros</router-link></li>
                    </ul>
                </li>
                
                <li class="dropdown" v-bind:class="data.pqrDisplay">
                    <a href="javascript:void(0);" v-on:click="toggleOptionsPQR()" class="dropdown-toggle active" data-toggle="dropdown">PQR <span class="caret" id="menu-pqr"></span></a>
                    <ul class="dropdown-menu">
                        <li v-if="config.hasPerm('add_pqr')"><router-link v-on:click.native="hideOptions()" to="/RegisterPqr">Registrar</router-link></li>
                        <li v-if="config.hasPerm('can_list_pqr') && config.hasPerm('can_retrieve_pqr') && config.hasPerm('change_pqr')"><router-link v-on:click.native="hideOptions()" to="/ConsultPqr">Consultar</router-link></li>
                        <li v-else-if="config.hasPerm('can_list_pqr')"><router-link v-on:click.native="hideOptions()" to="/ConsultPqr">Consultar</router-link></li>
                    </ul>
                </li>
            </ul>
            <ul class="nav navbar-nav navbar-right">
                <li><p class="date_bar">Bienvenido: {{ this.user }} Fecha: {{  this.date }} </p></li>
                <li><router-link v-on:click.native="logout()" to="/login">Cerrar Sesión</router-link></li>
            </ul>
        </div>
    </nav>
</template>

<script>
import Cookies from 'js-cookie'
import Config from '@/config'

export default{
    name: 'emt-menu-bar',
    data: function () {
        return {
            data: {
                adminDisplay: '',
                pqrDisplay: '',
                collapsed: true
            },
            Cookies: Cookies,
            config: Config,
            user: '',
            date: ''
        }
    },
    methods: {
        toggleCollapse: function (e) {
            var self = this
            e && e.preventDefault()
            self.data.collapsed = !self.data.collapsed
        },
        toggleOptionsAdmin: function () {
            var self = this
            if (self.data.adminDisplay === '') {
                self.data.adminDisplay = 'open'
            } else {
                self.data.adminDisplay = ''
            }

            if (self.data.adminDisplay === 'open') {
                self.data.pqrDisplay = ''
            }
        },
        toggleOptionsPQR: function () {
            var self = this
            if (self.data.pqrDisplay === '') {
                self.data.pqrDisplay = 'open'
            } else {
                self.data.pqrDisplay = ''
            }

            if (self.data.pqrDisplay === 'open') {
                self.data.adminDisplay = ''
            }
        },
        hideOptions: function () {
            var self = this
            self.data.adminDisplay = ''
            self.data.pqrDisplay = ''
        },
        logout: function () {
            Cookies.remove('token')
            Cookies.remove('idUser')
            Cookies.remove('permissions')
            Cookies.remove('username')
            Cookies.remove('perfil')
            Config.isLogin = false
            this.$parent.hideMenuBar()
        },
        listener: function (e) {
            var self = this
            if (e.target.toString() !== 'javascript:void(0);') {
                self.hideOptions()
            }
        }
    },
    created: function () {
        this.user = Cookies.get('username')
        this.date = new Date().toLocaleString()
        var self = this
        setInterval(function () {
            self.date = new Date().toLocaleString()
        }, 1000)
    },
    mounted: function () {
        var self = this
        window.addEventListener('click', self.listener)
    },
    destroyed: function () {
        var self = this
        window.removeEventListener('click', self.listener)
    }
}
</script>



// WEBPACK FOOTER //
// emt-menu-bar.vue?17d1d8f2